import { createBrowserRouter } from "react-router-dom";
import {
  Login,
  Summary,
  ManageFarmers,
  ManageSurveyors,
  AppLayout,
  Reset,
} from "../features/main";
import { Suspense } from "react";
import AppLayoutSkeleton from "../modules/molecules/layout/main";
import ErrorBoundary from "../modules/molecules/ErrorBoundary/main";
import { Box } from "../modules/molecules/mui/main";
import Reports from "../features/reports/main";
const appRouter = createBrowserRouter([
  {
    path: "/",

    element: (
      <ErrorBoundary>
        <AppLayout />
      </ErrorBoundary>
    ),

    children: [
      {
        path: "/summary",
        element: (
          <Suspense fallback={<AppLayoutSkeleton />}>
            <ErrorBoundary>
              <Summary />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "/manage-farmers",
        element: (
          <Suspense fallback={<AppLayoutSkeleton />}>
            <ErrorBoundary>
              <ManageFarmers />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "/manage-surveyors",
        element: (
          <Suspense fallback={<AppLayoutSkeleton />}>
            <ErrorBoundary>
              <ManageSurveyors />
            </ErrorBoundary>
          </Suspense>
        ),
      },
      {
        path: "/reports",
        element: (
          <Suspense fallback={<AppLayoutSkeleton />}>
            <Reports />
          </Suspense>
        ),
        errorElement: (
          <Box sx={{ height: "100vh" }}>
            Something went wrong please contact varaha admin
          </Box>
        ),
        children: [
          // {
          //   path: "/reports/:id",
          //   element: <SuperSetPage />,
          //   errorElement: (
          //     <Box sx={{ height: "100vh" }}>
          //       Something went wrong with super set please refresh the page
          //       again
          //     </Box>
          //   )
          // }
        ],
      },
    ],
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<h1>Loading</h1>}>
        <ErrorBoundary>
          <Login />
        </ErrorBoundary>
      </Suspense>
    ),
  },
  {
    path: "/password_change",
    element: (
      <Suspense fallback={<h1>Loading</h1>}>
        <ErrorBoundary>
          <Reset />
        </ErrorBoundary>
      </Suspense>
    ),
  },
  {
    path: "/password_change/:uuid",
    element: (
      <Suspense fallback={<h1>Loading</h1>}>
        <ErrorBoundary>
          <Reset />
        </ErrorBoundary>
      </Suspense>
    ),
  },
]);

export default appRouter;
